import React, { forwardRef } from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '../../lib/utils';

const textareaVariants = cva(
  'flex w-full rounded-md border bg-background text-sm shadow-sm ring-offset-background transition-[border-color,box-shadow,background-color] duration-fast ease-standard placeholder:text-muted-foreground focus-glow disabled:cursor-not-allowed disabled:opacity-50',
  {
    variants: {
      variant: {
        default: 'border-input',
        filled: 'border-transparent bg-muted/50',
        ghost: 'border-transparent bg-transparent shadow-none',
      },
      density: {
        comfortable: 'min-h-[96px] px-3 py-2',
        compact: 'min-h-[80px] px-3 py-1.5 text-xs',
      },
      state: {
        default: '',
        invalid: 'border-destructive focus-visible:ring-destructive/30',
        success: 'border-success focus-visible:ring-success/30',
      },
    },
    defaultVariants: {
      variant: 'default',
      density: 'comfortable',
      state: 'default',
    },
  }
);

export interface TextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement>,
    VariantProps<typeof textareaVariants> {}

const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(({
  className,
  variant,
  density,
  state,
  ...props
}, ref) => {
  return <textarea className={cn(textareaVariants({
    variant,
    density,
    state,
  }), className)} ref={ref} {...props} />;
});
Textarea.displayName = 'Textarea';
export { Textarea, textareaVariants };